// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export enum validationMode {
	QUIET = 'quiet',
	STANDARD = 'standard',
	COMPLETE = 'complete',
}
